import { EmployeeSearchScreen } from '@/components/EmployeeSearchScreen';

export default function EmployeeSearch() {
  return <EmployeeSearchScreen />;
}
